import { render, staticRenderFns } from "./UploadBackground.vue?vue&type=template&id=7d11c8bf"
import script from "./UploadBackground.vue?vue&type=script&lang=js"
export * from "./UploadBackground.vue?vue&type=script&lang=js"
import style0 from "./UploadBackground.vue?vue&type=style&index=0&id=7d11c8bf&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports